import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useWorkspace, timeLabel } from "./useWorkspace";
import { ReviewList, RuntimeNote } from "./WorkspaceCards";
export default function WorkDock() {
  const [tab, setTab] = useState("Needs you");
  const { data, isPending, error, refetch } = useWorkspace();
  return (
    <aside className="work-dock" aria-label="Your ongoing work">
      <header>
        <p className="workspace-eyebrow">Alongside your conversation</p>
        <h2>Your ongoing work</h2>
      </header>
      <nav aria-label="Ongoing work views">
        {["Needs you", "Goals", "Scheduled"].map((t) => (
          <button key={t} aria-pressed={tab === t} onClick={() => setTab(t)}>
            {t}
            {t === "Needs you" && data?.reviews.length > 0
              ? ` · ${data.reviews.length}`
              : ""}
          </button>
        ))}
      </nav>
      {isPending ? (
        <p role="status">Loading your work…</p>
      ) : error ? (
        <div>
          <p role="alert">Your work couldn’t load.</p>
          <button className="workspace-action" onClick={() => refetch()}>
            Try again
          </button>
        </div>
      ) : (
        <>
          {tab === "Needs you" && <ReviewList items={data.reviews} limit={4} />}{" "}
          {tab === "Goals" && (
            <>
              {data.goals.slice(0, 8).map((g) => (
                <Link
                  key={`${g.kind}:${g.id}`}
                  className="schedule-row"
                  to={g.link}
                >
                  <strong>{g.title}</strong>
                  <span>
                    {g.target ? `${g.completed || 0} / ${g.target} · ` : ""}
                    {g.today_ticked
                      ? "Done today"
                      : g.next_step || "Open workspace"}
                  </span>
                </Link>
              ))}
              <Link className="workspace-text-link" to="/goals">
                All goals
              </Link>
            </>
          )}
          {tab === "Scheduled" && (
            <>
              {data.watches.map((w) => (
                <Link key={w.id} className="schedule-row" to={w.link}>
                  <strong>{w.title}</strong>
                  <span>
                    {w.enabled
                      ? `Next check ${timeLabel(w.next_at, data.timezone)}`
                      : "Paused"}
                  </span>
                </Link>
              ))}
              <Link className="workspace-text-link" to="/manage?view=agent">
                Manage schedules
              </Link>
            </>
          )}
          <RuntimeNote data={data} />
        </>
      )}
    </aside>
  );
}
